import { render, staticRenderFns } from "./IssueDefinition.vue?vue&type=template&id=6d618d0e&scoped=true&"
import script from "./IssueDefinition.vue?vue&type=script&lang=js&"
export * from "./IssueDefinition.vue?vue&type=script&lang=js&"
import style0 from "./IssueDefinition.vue?vue&type=style&index=0&id=6d618d0e&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d618d0e",
  null
  
)

export default component.exports